export const pushTRecs = (...commands) => {
    const isTRecs = window.TRC && window.TRC.TRECS;

    if (!isTRecs) {
        return;
    }
    window._taboola.push(commands);
};
